import { component } from 'picoapp';
import { applyFilter } from 'utils/filter';

export default component((node: HTMLElement) => {
  const sort: HTMLSelectElement = node.querySelector('[data-sort]');
  const shadowSorts = Array.from(document.querySelectorAll<HTMLSelectElement>('[data-sort]')).filter((item) => item !== sort);

  const trigger: HTMLElement = node.querySelector('[data-trigger]');
  const dropdown: HTMLFormElement = node.querySelector('[data-dropdown]');

  dropdown.addEventListener('change', () => {
    const options = dropdown.querySelectorAll('input');
    sort.selectedIndex = [...options].findIndex((input) => input.checked);
    sort.dispatchEvent(new Event('change'));
  });

  const open = () => {
    dropdown.classList.remove('hidden');
    dropdown.setAttribute('aria-hidden', 'false');
  };

  const close = () => {
    dropdown.classList.add('hidden');
    dropdown.setAttribute('aria-hidden', 'true');
  };

  trigger.addEventListener('click', () => {
    if (dropdown.classList.contains('hidden')) open();
    else close();
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target as HTMLElement) && !trigger.contains(e.target as HTMLElement)) {
      close();
    }
  });

  sort.addEventListener('change', () => {
    const { value } = sort.options[sort.selectedIndex];
    const params = new URLSearchParams(window.location.search);
    params.set(sort.name, value);

    applyFilter(params.toString());
  });

  document.addEventListener('filter:reset', () => {
    sort.selectedIndex = 0;
    sort.dispatchEvent(new Event('change'));
  });

  // Mimick changes on other visible sort
  sort.addEventListener('change', () => {
    shadowSorts.forEach((item) => {
      item.selectedIndex = sort.selectedIndex;
    });
  })
});
